import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";

/**
 * A special form-like element that supports nesting so that form validation can be used but nested forms ignored
 * @component 
 */
const ReactForm = forwardRef(({ children, ...props }, ref) => {
    const formRef = useRef();

    const checkValidity = useCallback(() => {
        const controls = formRef.current.querySelectorAll('input, select, textarea');
        return Array.from(controls).reduce((valid, control) => {
            if (control.closest('div[data-react-form]') === formRef.current) {
                const controlValid = control.checkValidity();
                return valid && controlValid;
            }
            return valid;
        }, true);
    }, [])

    useImperativeHandle(ref, () => ({
        checkValidity
    }));

    return <div ref={formRef} data-react-form {...props}>
        {children}
    </div>
});

export default ReactForm;